(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-diptych-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bandLink = document.querySelector(
      '.image-diptych-banner__band .image-diptych-banner__link'
    );
    if (!bandLink) return;

    var REVEAL_MS = 2000;
    var revealed = false;
    var hideTimer = null;

    var hasRealHover = function () {
      return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    };

    bandLink.addEventListener('touchstart', function () {
      if (hasRealHover()) return;
      bandLink.classList.add('is-touch-active');
    }, { passive: true });

    bandLink.addEventListener('click', function (e) {
      if (hasRealHover()) return;

      if (!revealed) {
        e.preventDefault();
        revealed = true;

        clearTimeout(hideTimer);
        hideTimer = setTimeout(function () {
          bandLink.classList.remove('is-touch-active');
          revealed = false;
        }, REVEAL_MS);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
